import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE as NAMESPACE } from 'main/common'
import { useWhitelabel } from 'main/framework'

import { FilterControl } from '../common'
import IFullSearchProps from '../types'
import FilterForm from './FilterForm'

export default function ProgramOfferingsFilter(props: IFullSearchProps) {
  const {
    filters,
    displayForm,
    palette,
    onChangeFilters,
    onRequestCloseForm,
    onRequestDisplayForm,
  } = props

  const { t } = useTranslation(NAMESPACE)
  const { networkProgramOfferings } = useWhitelabel()

  const selected = filters.selectedProgramOfferings.sort()
  const isActive = !!selected.length

  const displayLabel = React.useMemo(() => {
    return selected.length > 0
      ? networkProgramOfferings
          .filter(po => selected.includes(po.id))
          .map(po => t(`PROGRAM-OFFERING-${po.slug.toUpperCase()}`))
          .join(', ')
      : t('FILTERBAR-PROGRAM-OFFERINGS-LABEL')
  }, [networkProgramOfferings, selected, t])

  return (
    <div>
      <FilterControl
        isActive={isActive}
        label={displayLabel}
        displayForm={displayForm}
        palette={palette}
        onRequestCloseForm={onRequestCloseForm}
        onRequestDisplayForm={onRequestDisplayForm}
        filterForm={
          <FilterForm
            filters={filters}
            onChangeFilters={onChangeFilters}
            onRequestCloseForm={onRequestCloseForm}
          />
        }
      />
    </div>
  )
}
